import { Box, Stack, styled } from '@mui/material';

export const ContentWrapper = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: theme.spacing(3),

  [theme.breakpoints.up('md')]: {
    maxWidth: 400,
    alignSelf: 'center',
    width: '100%',
  },
}));

export const CardWrapper = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: 12,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.common.white,
  width: '100%',
  margin: '0 auto',
}));
